/* eslint-disable no-param-reassign */

import { CalibrationModel } from 'api';
import { Calibration } from '../../../../../common/types/valuation';
import { IReverseParserCalibrationParams } from '../../guidelinePublicCompanies/PerformanceMetrics/config/reverseParser/types';
import { ICellChange } from '../../guidelinePublicCompanies/PerformanceMetrics/config/utils/types';

type CalibrationFieldProperties = Exclude<keyof Calibration, 'id' | 'deleted_at'>;
interface ICalibrationKeyFieldsToUpdate {
  key: CalibrationFieldProperties;
  cell: ICellChange;
  defaultValue: string | number;
}
const reverseParserCalibrationOutputs = ({ cells, tableData }: IReverseParserCalibrationParams) => {
  const calibrationKeyFieldsToUpdate: ICalibrationKeyFieldsToUpdate[] = [
    { key: 'ltm_revenue_multiple', cell: cells.A2, defaultValue: 0 },
    { key: 'ntm_revenue_multiple', cell: cells.A3, defaultValue: 0 },
    { key: 'ltm_revenue_multiple_percentile', cell: cells.A4, defaultValue: 0 },
    { key: 'ntm_revenue_multiple_percentile', cell: cells.A5, defaultValue: 0 },
    { key: 'revenue_premium_formula_selector', cell: cells.A6, defaultValue: CalibrationModel.revenue_premium_formula_selector.MEDIAN },
    { key: 'ltm_revenue_multiple_premium', cell: cells.A7, defaultValue: 0 },
    { key: 'ntm_revenue_multiple_premium', cell: cells.A8, defaultValue: 0 },
    { key: 'ltm_ebitda_multiple', cell: cells.A10, defaultValue: 0 },
    { key: 'ntm_ebitda_multiple', cell: cells.A11, defaultValue: 0 },
    { key: 'ltm_ebitda_multiple_percentile', cell: cells.A12, defaultValue: 0 },
    { key: 'ntm_ebitda_multiple_percentile', cell: cells.A13, defaultValue: 0 },
    { key: 'ebitda_premium_formula_selector', cell: cells.A14, defaultValue: CalibrationModel.ebitda_premium_formula_selector.MEDIAN },
    { key: 'ltm_ebitda_multiple_premium', cell: cells.A15, defaultValue: 0 },
    { key: 'ntm_ebitda_multiple_premium', cell: cells.A16, defaultValue: 0 },
  ];

  calibrationKeyFieldsToUpdate.forEach(({ key, cell, defaultValue }) => {
    let value = defaultValue;

    // 'string' based defaults leverage nullish coalescing operator where number based defaults use ternary operator
    if (typeof defaultValue === 'string') {
      value = cell.value?.toString().toLowerCase() ?? defaultValue;
    } else {
      value = Number.isNaN(Number(cell.value)) ? defaultValue : Number(cell.value);
    }

    // must cast key as CalibrationFieldProperties to avoid type error
    (tableData.calibration[key as CalibrationFieldProperties] as string) = String(value);
  });
};

export default reverseParserCalibrationOutputs;
